import { SearchableSelect } from '@/components/ui/SearchableSelect';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps {
  label?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  name?: string;
  required?: boolean;
  searchPlaceholder?: string;
  /** Show search input in the dropdown (default true). */
  showSearch?: boolean;
  /** Allow clearing the selection with an inline X on the trigger (default: not required). */
  allowClear?: boolean;
  /** Raise dropdown above sidebar when used in the workspace header. */
  headerOverlay?: boolean;
}

/** Searchable single-select — thin wrapper used across the app for consistent search + clear UX. */
export function Select({
  placeholder = 'Select…',
  showSearch = true,
  allowClear,
  headerOverlay,
  ...props
}: SelectProps) {
  return (
    <SearchableSelect
      {...props}
      placeholder={placeholder}
      showSearch={showSearch}
      allowClear={allowClear}
      headerOverlay={headerOverlay}
    />
  );
}
